class CompleteTheLookDynamic {
  constructor() {
    this.sectionId = null;
    this.currentVariantId = null;
    this.completeTheLookSection = null;
    this.unsubscriber = null;
    this.init();
  }

  init() {
    console.log("🚀 Initializing Complete the Look Dynamic...");

    // Find the complete the look section
    this.completeTheLookSection = document.querySelector(
      ".section-complete-the-look"
    );

    if (!this.completeTheLookSection) {
      console.log("❌ Complete the Look section not found");
      return;
    }

    console.log("✅ Complete the Look section found");

    // Subscribe to variant changes - this is the key part
    this.unsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      console.log("🔄 Variant change detected:", event);
      this.handleVariantChange(event);
    });

    // Also listen for initial variant selection
    this.getCurrentVariant();

    console.log("✅ Complete the Look Dynamic initialized");
  }

  getSectionId() {
    // Try to get section ID from a product section on the page
    const productSection = document.querySelector('[data-section*="product"]');
    if (productSection) {
      const sectionId = productSection.dataset.section;
      return sectionId;
    }
    return null;
  }

  getCurrentVariant() {
    // Get the currently selected variant
    const variantData = document.querySelector("[data-selected-variant]");
    if (variantData) {
      try {
        const variant = JSON.parse(variantData.innerHTML);
        if (variant && variant.id) {
          this.currentVariantId = variant.id;
          this.updateCompleteTheLook(variant.id);
        }
      } catch (e) {
        console.error("Error parsing current variant:", e);
      }
    }
  }

  handleVariantChange(event) {
    if (event.data.variant && event.data.variant.id) {
      const newVariantId = event.data.variant.id;

      // Only update if variant actually changed
      if (this.currentVariantId !== newVariantId) {
        this.currentVariantId = newVariantId;
        this.updateCompleteTheLook(newVariantId);
      }
    }
  }

  async updateCompleteTheLook(variantId) {
    if (!this.completeTheLookSection) return;

    console.log("🔄 Updating Complete the Look for variant:", variantId);

    // Add loading state
    this.completeTheLookSection.classList.add("updating");

    try {
      // Force update the section regardless of metafield checks
      // This ensures the section always refreshes with the new variant context
      await this.forceRenderSection(variantId);
    } catch (error) {
      console.error("Error updating Complete the Look:", error);
      this.handleFallback();
    } finally {
      // Remove loading state
      this.completeTheLookSection.classList.remove("updating");
    }
  }

  async forceRenderSection(variantId) {
    console.log("🚀 Force rendering section for variant:", variantId);

    try {
      // Update URL with variant parameter and force refresh the page content
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", variantId);

      const response = await fetch(newUrl.toString(), {
        method: "GET",
        headers: {
          Accept: "text/html",
        },
      });

      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Find the complete the look section in the new HTML
        const newSection = doc.querySelector(".section-complete-the-look");

        if (newSection) {
          const newWrapper = newSection.querySelector(
            ".complete-the-look-wrapper"
          );
          const currentWrapper = this.completeTheLookSection.querySelector(
            ".complete-the-look-wrapper"
          );

          if (newWrapper && currentWrapper) {
            console.log("✅ Replacing section content...");

            // Smooth transition
            currentWrapper.style.transition = "opacity 0.3s ease";
            currentWrapper.style.opacity = "0.3";

            setTimeout(() => {
              currentWrapper.innerHTML = newWrapper.innerHTML;
              currentWrapper.style.opacity = "1";
              this.reinitializeComponents();

              // Show section if it was hidden
              this.completeTheLookSection.classList.remove(
                "complete-the-look-hidden"
              );

              console.log("✅ Section updated successfully!");
            }, 200);
          }
        } else {
          console.log("⚠️ No complete the look section found");
          this.handleFallback();
        }
      }
    } catch (error) {
      console.error("❌ Force render failed:", error);
      this.handleFallback();
    }
  }

  async fetchVariantData(variantId) {
    // Fetch variant data with metafields
    // This uses Shopify's AJAX API to get variant info
    try {
      const response = await fetch(`/variants/${variantId}.js`);
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.error("Error fetching variant data:", error);
    }
    return null;
  }

  hasCompleteTheLookData(variantData) {
    // Check if the variant has complete the look metafields
    return (
      variantData.metafields &&
      (variantData.metafields["custom.complete_the_look_1"] ||
        variantData.metafields["custom.complete_the_look_2"] ||
        variantData.metafields["custom.complete_the_look"] ||
        variantData.metafields["custom.variant_complete_the_look_1"] ||
        variantData.metafields["custom.variant_complete_the_look_2"] ||
        variantData.metafields["custom.variant_complete_the_look_more"])
    );
  }

  async renderUpdatedSection(variantData) {
    // Use section rendering approach for Shopify
    const sectionId =
      this.completeTheLookSection.dataset.sectionId || "complete-the-look";

    try {
      // Construct URL for section rendering with current variant
      const sectionUrl = `${window.location.pathname}?section_id=${sectionId}&variant=${this.currentVariantId}`;

      const response = await fetch(sectionUrl, {
        method: "GET",
        headers: {
          Accept: "text/html",
        },
      });

      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Find the new section content
        const newSectionContent =
          doc.querySelector(".complete-the-look-wrapper") ||
          doc.querySelector(
            ".section-complete-the-look .complete-the-look-wrapper"
          );

        if (newSectionContent) {
          const currentContent = this.completeTheLookSection.querySelector(
            ".complete-the-look-wrapper"
          );
          if (currentContent) {
            // Fade out, replace content, fade in
            currentContent.style.opacity = "0.5";

            setTimeout(() => {
              currentContent.innerHTML = newSectionContent.innerHTML;
              currentContent.style.opacity = "1";

              // Reinitialize components
              this.reinitializeComponents();
            }, 150);
          }
        } else {
          // If no content found, hide the section.
          this.completeTheLookSection.classList.add("complete-the-look-hidden");
        }
      }
    } catch (error) {
      console.error("Error rendering updated section:", error);
      this.handleFallback();
    }
  }

  handleFallback() {
    // Hide the section if no variant-specific or product-level data is available
    const hasAnyProducts =
      this.completeTheLookSection.querySelector(".grid__item");
    if (!hasAnyProducts) {
      this.completeTheLookSection.classList.add("complete-the-look-hidden");
    }
  }

  reinitializeComponents() {
    // Reinitialize slider components if they exist
    const sliderComponent =
      this.completeTheLookSection.querySelector("slider-component");
    if (sliderComponent && typeof sliderComponent.init === "function") {
      sliderComponent.init();
    }
  }

  destroy() {
    if (this.unsubscriber) {
      this.unsubscriber();
    }
  }
}

// Initialize when DOM is ready or if already loaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new CompleteTheLookDynamic();
  });
} else {
  new CompleteTheLookDynamic();
}
